/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './AiAccessControlsChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService#getAccessControls
 */
export const GET_ACCESS_CONTROLS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getAccessControls',
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getAccessControlsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService#patchAccessControls
 */
export const PATCH_ACCESS_CONTROLS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'patchAccessControls',
  args: ['generativeAiEnabled', 'crmPropertiesEnabled', 'conversationDataEnabled', 'fileDataEnabled', 'copilotEnabled'],
  fetcher(request, ctx) {
    return chirpClient.call(References.patchAccessControlsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});